import { Button, Form, Input, Modal, Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import PriceInputModal from '../../components/modal/PriceInputModal';
import '../../css/modal.scss';
import {
  paymentMethodCode,
  paymentMethodString,
  modalErrorStyle,
} from '../../lib/util/codeUtil';
import { comma } from '../../lib/util/numberUtil';
import Const from "../../const";
import image from '../../res/image';

const maxPaymentCount = 10;

const PaymentDialog = ({
  close,
  orderPayments,
  handlePaymentChange,
  editable,
  orderPrice,
}) => {
  const formRef = useRef(null);
  const Option = Select.Option;
  const FormItem = Form.Item;

  const [list, setList] = useState([]);
  const [latestIdx, setLatestIdx] = useState(0);
  const [balance, setBalance] = useState(0);
  const [inputId, setInputId] = useState(0);
  const [priceInputModalOpen, setPriceInputModalOpen] = useState(false);

  useEffect(() => {
    const { list_, latestIdx_ } = makeList(orderPayments);
    setList(list_);
    setLatestIdx(latestIdx_);
    setBalance(orderPrice - calcOrderPrice(list_));
  }, [orderPayments]);

  const makeList = (orderPayments) => {
    let list_ = [];
    let latestIdx_ = 0;

    list_.push({
      idx: ++latestIdx_,
      paymentMethod: paymentMethodCode.cash,
      paymentAmount: 0,
      paymentStatus: 1,
    });
    list_.push({
      idx: ++latestIdx_,
      paymentMethod: paymentMethodCode.advance,
      paymentAmount: 0,
      paymentStatus: 1,
    });
    list_.push({
      idx: ++latestIdx_,
      paymentMethod: paymentMethodCode.card,
      paymentAmount: 0,
      paymentStatus: 1,
    });
    if (orderPayments.length > 0) {
      orderPayments.forEach((payment) => {
        let p = list_.find((x) => x.paymentMethod === payment.paymentMethod);
        if (p !== null && typeof p !== 'undefined') {
          p.paymentAmount += payment.paymentAmount;
        }
      });
    }
    return { list_, latestIdx_ };
  };
  const calcOrderPrice = (orderPayments) => {
    let price = 0;
    orderPayments.forEach((payment) => {
      price += payment.paymentAmount;
    });
    return price;
  };

  /*
  const handlePlus = () => {
    if (list.length >= maxPaymentCount) {
      Modal.error({
          title: "분할결제 등록 오류",
          content: (
              <div>
                분할 결제는 {maxPaymentCount}개를 초과할 수 없습니다. 다시 시도해 주십시오.
              </div>
          )
      });
      return;
    }

    let latestIdx_ = latestIdx;
    setList(
        list.concat({
            idx: ++latestIdx_,
            paymentMethod: paymentMethodCode.card,
            paymentAmount: 0,
            paymentStatus: 1,
        })
    );
    setLatestIdx(latestIdx_);

    // @todo riverstyx
    // const control = formRef.current.getFieldInstance('input'+ inputId);
    // if (typeof control !== 'undefined')
    // {
    //   control.focus({cursor: 'all'});
    // }
  };
  const handleMinus = (index) => {
      const list_ = list.filter((x) => x.idx !== index);
      setList(list_);
      setBalance(orderPrice - calcOrderPrice(list_));
  };
  */
  const handleChange = (index, text) => {
    list[index].paymentAmount = parseInt(
      text === '' ? '0' : text.trim().replace(/,/g, '')
    );
    setList(list);
    setBalance(orderPrice - calcOrderPrice(list));
  };
  const handleMax = (index) => {
    let value = calcOrderPrice(list);
    if (orderPrice <= value) {
      return;
    }
    if (list.length === 1) {
      value = 0;
    }
    const balance_ = orderPrice - value;
    const amount = list[index].paymentAmount + balance_;
    handleChange(index, amount + '');

    const inputId_ = list[index].idx;
    formRef.current.setFieldsValue({
      ['input' + inputId_]: comma(amount),
    });
  };
  const handleResetAll = () => {
    for (let index = 0; index < list.length; ++index) {
      handleReset(index);
    }
  };
  const handleReset = (index) => {
    list[index].paymentAmount = 0;
    setList(list);
    setBalance(orderPrice - calcOrderPrice(list));

    const inputId_ = list[index].idx;
    formRef.current.setFieldsValue({
      ['input' + inputId_]: comma(0),
    });
  };

  const onOpenPriceInputModal = (id) => {
    setPriceInputModalOpen(true);
    setInputId(id);
  };
  const onClosePriceInputModal = () => {
    setPriceInputModalOpen(false);
    setInputId(0);
  };
  const onOk = () => {
    for (let i = 0; i < list.length; i++) {
      if (list[i].paymentAmount < 0) {
        Modal.error({
          title: '설정 오류',
          content: <div>결제금액은 0보다 작을 수 없습니다.</div>,
          ...modalErrorStyle,
        });
        return;
      }
    }

    const value = calcOrderPrice(list);

    if (orderPrice > 0 && value > orderPrice) {
      Modal.error({
        title: '설정 오류',
        content: (
          <div>결제 금액이 초과 되었습니다. 남은금액을 확인해주세요!!</div>
        ),
        ...modalErrorStyle,
      });
      return;
    }
    if (orderPrice > 0 && value !== orderPrice) {
      Modal.error({
        title: '설정 오류',
        content: (
          <div>결제 금액이 남아 있습니다. 남은금액을 확인해주세요!!</div>
        ),
        ...modalErrorStyle,
      });
      return;
    }
    handlePaymentChange(list.filter((x) => x.paymentAmount > 0));
    close();
  };

  const skinType = Const.skinType.toUpperCase();

  return (
    <React.Fragment>
      <div className="Modal-detail-overlay" onClick={() => close()} />
      <Form ref={formRef}>
        <div className="Modal-detail payment" style={{ textAlign: 'left' }}>
          {/* 타이틀 */}
          <div className="detail-title">
            <div>결제내역</div>
            <div onClick={() => close()}>
              {' '}
              <img
                style={{ display: 'inline' }}
                src={image.closeIcon}
                alt="exit"
              />{' '}
            </div>
          </div>

          {/* 컨텐츠 */}
          <div className="detail-content">
            <div className="split-content-box">
              <div className="split-content-title">
                <div>내역수정</div>
                <div className="plus-btn">
                  {editable && (
                    <Button
                      onClick={() => {
                        handleResetAll();
                      }}>
                      전체 리셋
                    </Button>
                  )}
                </div>
              </div>

              <div>
                {list.length > 0 ? (
                  // <FormItem name="splitPayment">
                  <div>
                    {list.map((orderPayment, i) => {
                      return (
                        <div
                          className={skinType === "GOGOIT" ? "gogoit-split-payment-box" : "split-payment-box"}
                          key={orderPayment.idx}>
                          <div>
                            {paymentMethodString[orderPayment.paymentMethod]}
                          </div>
                          <div>
                            <div className="payment-form">
                              {editable ? (
                                <FormItem name={'input' + orderPayment.idx}>
                                  <Input
                                    className="payment-input"
                                    key={orderPayment.idx}
                                    id={orderPayment.idx}
                                    defaultValue={comma(
                                      orderPayment.paymentAmount
                                    )}
                                    onFocus={() =>
                                      onOpenPriceInputModal(orderPayment.idx)
                                    }
                                    onChange={(e) => {
                                      handleChange(i, e.target.value);
                                    }}></Input>
                                </FormItem>
                              ) : (
                                <Input
                                  value={orderPayment.paymentAmount}></Input>
                              )}
                            </div>

                            <div className="modal-03 paymentKeypad">
                              <PriceInputModal
                                isOpen={priceInputModalOpen}
                                close={onClosePriceInputModal}
                                keyadd={(text) => {
                                  const value = list.find(
                                    (x) => x.idx === inputId
                                  );
                                  if (value !== null) {
                                    value.paymentAmount =
                                      value.paymentAmount + parseInt(text);
                                  }
                                  formRef.current.setFieldsValue({
                                    ['input' + inputId]: comma(
                                      value.paymentAmount
                                    ),
                                  });
                                  setBalance(orderPrice - calcOrderPrice(list));
                                }}
                                keyin={(text) => {
                                  const value = list.find(
                                    (x) => x.idx === inputId
                                  );
                                  if (value !== null) {
                                    value.paymentAmount = parseInt(
                                      value.paymentAmount + '' + text
                                    );
                                  }
                                  formRef.current.setFieldsValue({
                                    ['input' + inputId]: comma(
                                      value.paymentAmount
                                    ),
                                  });
                                  setBalance(orderPrice - calcOrderPrice(list));
                                }}
                                backspace={() => {
                                  const value = list.find(
                                    (x) => x.idx === inputId
                                  );
                                  if (value !== null) {
                                    value.paymentAmount = Math.floor(
                                      value.paymentAmount / 10
                                    );
                                  }
                                  formRef.current.setFieldsValue({
                                    ['input' + inputId]: comma(
                                      value.paymentAmount
                                    ),
                                  });
                                  setBalance(orderPrice - calcOrderPrice(list));
                                }}
                                reset={() => {
                                  const value = list.find(
                                    (x) => x.idx === inputId
                                  );
                                  if (value !== null) {
                                    value.paymentAmount = 0;
                                  }
                                  formRef.current.setFieldsValue({
                                    ['input' + inputId]: comma(
                                      value.paymentAmount
                                    ),
                                  });
                                  setBalance(orderPrice - calcOrderPrice(list));
                                }}
                                ok={() => {
                                  onClosePriceInputModal();
                                }}
                              />
                            </div>
                          </div>

                          <div className="split-btn">
                            {editable && (
                              <>
                                <Button
                                  type="primary"
                                  style={{ marginRight: 10 }}
                                  onClick={() => handleMax(i)}>
                                  최대
                                </Button>
                                <Button
                                  type="primary"
                                  onClick={() => handleReset(i)}>
                                  리셋
                                </Button>
                              </>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  // </FormItem>

                  <div className="orderPayments-wrapper">
                    결제 정보가 존재하지 않습니다.
                  </div>
                )}
              </div>

              <div className="split-bottom-box">
                <div>
                  {orderPrice > 0 ? `남은금액` : `주문금액`} :{' '}
                  {comma(balance) + ' 원'}
                </div>
                <div className="split-bottom-btn mobileoff">
                  {editable && (
                    <Button
                      style={{ width: 120, height: 40, fontSize: 18 }}
                      type="primary"
                      onClick={onOk}>
                      등록하기
                    </Button>
                  )}
                </div>
                <div className="split-bottom-btn mobile">
                  {editable && (
                    <Button
                      style={{
                        width: 90,
                        fontSize: 14,
                        height: 32,
                        borderRadius: 5,
                      }}
                      type="primary"
                      onClick={onOk}>
                      등록하기
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </React.Fragment>
  );
};
export default PaymentDialog;
